import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import isDeepEqual from 'lodash/isEqual';

import { getMappingSourceProperties } from 'pages/mapping/controllers/actions';
import { selectMappingSourceProperties } from 'pages/mapping/controllers/selectors';

export const useGetMappingSourceProperties = () => {
  const dispatch = useDispatch();
  const mappingSourceProperties = useSelector(selectMappingSourceProperties());

  useEffect(() => {
    if (!mappingSourceProperties?.data) {
      dispatch(getMappingSourceProperties({ pageIndex: 1, pageSize: 9999 }));
    }
    return;
  }, [dispatch, mappingSourceProperties.data]);

  return {
    status: mappingSourceProperties.status,
    mappingProperties: mappingSourceProperties.data ?? [],
  };
};

const useCustomCompareEffect = (effectCallback, deps, deepEqualFn) => {
  const ref = useRef(undefined);

  if (!ref.current || !deepEqualFn(deps, ref.current)) {
    ref.current = deps;
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(effectCallback, ref.current);
};

const isPrimitive = (val) => {
  const type = typeof val;
  return val === null || (type !== 'object' && type !== 'function');
};

// This hook should be used with dependencies are non-primitive type
export const useDeepCompareEffect = (effectCallback, deps) => {
  if (!(deps instanceof Array) || !deps.length) {
    console.warn(
      '`useDeepCompareEffect` should not be used with no dependencies. Use React.useEffect instead.'
    );
  }

  if (deps.every(isPrimitive)) {
    console.warn(
      '`useDeepCompareEffect` should not be used with dependencies that are all primitive values. Use React.useEffect instead.'
    );
  }

  useCustomCompareEffect(effectCallback, deps, isDeepEqual);
};
